import { useState } from 'react';

const UNREAD_ONLY_STORAGE_KEY = 'notifications.unreadOnly';

const readStoredValue = () => {
  try {
    return localStorage.getItem(UNREAD_ONLY_STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
};

const useUnreadOnlyFilter = () => {
  const [unreadOnly, setUnreadOnlyState] = useState(readStoredValue);

  const setUnreadOnly = (value: boolean) => {
    setUnreadOnlyState(value);
    try {
      localStorage.setItem(UNREAD_ONLY_STORAGE_KEY, String(value));
    } catch {
      // storage unavailable: the filter just isn't persisted
    }
  };

  return { unreadOnly, setUnreadOnly };
};

export default useUnreadOnlyFilter;
